import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BodyTextSmall } from "~/components/Typographies";

const GridLoadingOverlay = () => {
	const { t } = useTranslation("common");

	return (
		<Box
			sx={{
				alignItems: "center",
				color: "text.secondary",
				display: "flex",
				flexDirection: "column",
				gap: 1.5,
				p: 4
			}}
		>
			<CircularProgress size={32} />
			<BodyTextSmall sx={{ color: "text.secondary" }}>{t("grid.loading")}</BodyTextSmall>
		</Box>
	);
};

export default GridLoadingOverlay;
